export const fieldConfig = {
  isCollect: {
    title: '',
    key: 'isCollect',
    width: 50,
  },
  planName: {
    title: '计划名称',
    key: 'planName',
    width: 150,
  },
  planStatus: {
    title: '计划状态',
    key: 'planStatus',
    width: 140,
  },
  planTypeVal: {
    title: '计划类型',
    key: 'planTypeVal',
    width: 100,
  },
  planTime: {
    title: '计划时间',
    key: 'planTime',
    width: 310,
  },
  title: {
    title: '关联问卷',
    key: 'title',
    width: 220,
  },
  remake:{
    title: '计划说明',
    key: 'remake',
    tip: true,
  },
  createDate: {
    title: '计划创建时间',
    key: 'createDate',
    width: 170,

  },
};

export const planTypeOptions = [
  {
    value: 'YYT',
    label: '营业厅',
  },
  {
    value: 'QX',
    label: '抢修',
  },
  {
    value: 'DD',
    label: '工单',
  },
]
export const timeSelect = {
  label: '时间类型',
  value: [
    {
      value: '',
      label: '全部时间',
    },
    {
      value: 0,
      label: '最近一周',
    },
    {
      value: 1,
      label: '最近半个月',
    },
    {
      value: 2,
      label: '最近一个月',
    },
  ],
  default: '',
};
export const statusSelect = {
  label: '计划状态',
  value: [
    {
      value: '',
      label: '全部状态',
    },
    {
      value: 'UNPUBLISH',
      label: '未发布',
    },
    {
      value: 'PROGRESS',
      label: '进行中',
    },
    {
      value: 'ENDED',
      label: '已完成',
    },
  ],
  default: '',
};
// 0 1 2
export const PLANSTATUS_ENUM = 
{
  UNPUBLISH:{
    value:0,
    label:'未发布'
  },
  PROGRESS:{
    value:1,
    label:'进行中'
  },
  ENDED:{
    value:2,
    label:'已完成'
  },
};


export const selectOptionsDict = Object.freeze({
  // timeType: timeSelect,
  statusType: statusSelect,
});
